import { Button, ClickAwayListener, Grow, MenuList, Paper, Popper } from '@mui/material';
import { FC } from 'react';
import { MayaMenuEntryStyles, MayaMenuSecondaryLevelEntryStyles } from './MayaMenuEntry.styles';
import useMayaMenuEntry from 'components/MayaMenuEntry/MayaMenuEntry.hook';
import { MayaMenuEntryPropsType } from 'components/MayaMenuEntry/MayaMenuEntry.types';
import Box from 'yoda-ui/components/Box';

const MayaMenuEntry: FC<MayaMenuEntryPropsType> = ({ title, currentLocation, activeRoute: activePaths, onClick, childrens }) => {
  const {
    anchorRef,
    handleClose,
    handleListKeyDown,
    handleToggle,
    navigate,
    open,
    setOpen,
  } = useMayaMenuEntry();

  return (
    childrens
      ? <>
        <Button
          ref={ anchorRef }
          id="composition-button"
          aria-controls={ open ? 'composition-menu' : undefined }
          aria-expanded={ open ? 'true' : undefined }
          aria-haspopup="true"
          onClick={ handleToggle }
          sx={ MayaMenuEntryStyles }
          data-current={ activePaths.filter((route) => currentLocation.includes(route)).length > 0 }
        >
          { title }
        </Button>
        <Popper
          open={ open }
          anchorEl={ anchorRef.current }
          role={ undefined }
          placement="bottom-start"
          transition
          disablePortal
        >
          {
            ({ TransitionProps, placement }) => (
              <Grow
                { ...TransitionProps }
                style={ { transformOrigin: placement === 'bottom-start' ? 'left top' : 'left bottom' } }
              >
                <Paper>
                  <ClickAwayListener onClickAway={ handleClose }>
                    <MenuList
                      autoFocusItem={ open }
                      id="composition-menu"
                      aria-labelledby="composition-button"
                      onKeyDown={ handleListKeyDown }
                    >
                      {
                        childrens.map((itemMenu) => {
                          return itemMenu.enable && (
                            <Box
                              className='MayaMenu-item'
                              key={ itemMenu.id }
                              sx={ MayaMenuEntryStyles && MayaMenuSecondaryLevelEntryStyles }
                            >
                              <MayaMenuEntry
                                title={ itemMenu.title }
                                onClick={
                                  itemMenu.targetRoute ? () => {
                                    navigate(itemMenu.targetRoute as string);
                                    setOpen(false);
                                  } : undefined
                                }
                                currentLocation={ currentLocation }
                                activeRoute={ itemMenu.activeRoute }
                                childrens={ itemMenu.childrens }
                              />
                            </Box>
                          );
                        })
                      }
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )
          }
        </Popper>
      </>
      : <Button
        sx={ MayaMenuEntryStyles }
        onClick={ onClick }
        data-current={ activePaths.filter((route) => currentLocation.includes(route)).length > 0 }
      >
        { title }
      </Button>
  );
};

export default MayaMenuEntry;
